import { Sheet } from '../../../lib/Types'

const DAYS_UNTIL_PAYMENT_REQUIRED = 14

type UnpaidSheet = Sheet & { is_free?: boolean }

const isUnpaid = (sheet: UnpaidSheet): boolean =>
  !sheet.is_paid && !sheet.has_accepted_payment && !sheet.is_free

const daysSinceCreated = (sheet: Sheet): number =>
  (Date.now() - new Date(sheet.created_date).getTime()) / (1000 * 60 * 60 * 24)

export const isPaymentOverdue = (sheet: UnpaidSheet): boolean =>
  isUnpaid(sheet) && daysSinceCreated(sheet) > DAYS_UNTIL_PAYMENT_REQUIRED

export const isOnActiveTrial = (sheet: UnpaidSheet): boolean =>
  isUnpaid(sheet) && daysSinceCreated(sheet) <= DAYS_UNTIL_PAYMENT_REQUIRED

// A free budget gets full access to premium features for the same 14 days
// a paid trial does — after that, premium features lock behind a paywall,
// unless the budget has since been paid/accepted (e.g. upgraded).
export const isFreeBudgetPremiumLocked = (sheet: UnpaidSheet): boolean =>
  !!sheet.is_free &&
  !sheet.is_paid &&
  !sheet.has_accepted_payment &&
  daysSinceCreated(sheet) > DAYS_UNTIL_PAYMENT_REQUIRED

// Purely time-based: whether a free budget is still within its first 14
// days, regardless of paid/accepted status — used for the card's label.
export const isFreeBudgetInPremiumPeriod = (sheet: UnpaidSheet): boolean =>
  !!sheet.is_free && daysSinceCreated(sheet) <= DAYS_UNTIL_PAYMENT_REQUIRED

export const getTrialEndDate = (sheet: Sheet): Date => {
  const endDate = new Date(sheet.created_date)
  endDate.setDate(endDate.getDate() + DAYS_UNTIL_PAYMENT_REQUIRED)
  return endDate
}
